// Import React
import React from "react";

// Import the shared info icon
import { InfoIcon } from "global/components/InfoButton";



// Export the reusable select field
export default function PodDesignAiSelectField({
    label,
    value,
    onChange,
    options,
    disabled,
    aiModelsInfoTable,
    setShowAiModelsTable,
}) {

    // Return the select field UI
    return (

        <div className="podDesignAiSelectField">

            {/* This is the field label */}
            <div className="podDesignAiSelectField__label">

                {label}

                {aiModelsInfoTable && (

                    <button
                        type="button"
                        className="info-button"
                        onClick={() => setShowAiModelsTable(true)}
                        aria-label="Compare AI models"
                        aria-haspopup="dialog"
                        title="Compare AI models"
                    >

                        <InfoIcon />

                    </button>

                )}

            </div>

            {/* This is the select input */}
            <select
                className="podDesignAiSelectField__select"
                aria-label={label}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled}
            >

                {/* Loop through the options */}
                {options.map((option) => (

                    <option
                        key={option.value}
                        value={option.value}
                    >

                        {option.label}

                    </option>

                ))}

            </select>

        </div>

    );
    
}